export const getUniqueClassName = (entityId, entityPrefix) => {
    const id = entityId.replace(/#/g, "-");
    return `rj-ev-list__${entityPrefix}-${id || "empty"}`;
};
//# sourceMappingURL=getUniqueClassName.js.map